<template>
  <AnnouncementModalContent image="user-portfolio" class="public-portfolio-announcement-modal">
    <div class="public-portfolio-announcement-modal__content">
      <BravadoText class="public-portfolio-announcement-modal__title">
        Profile built exclusively
        <br />
        to help sales professionals:
      </BravadoText>
      <BravadoText tag="h4" variant="header4" class="public-portfolio-announcement-modal__headline">
        Seller Portfolio
      </BravadoText>
      <BravadoButtonV3
        variant="secondary"
        :to="`/p/${$auth.user.slug}`"
        class="public-portfolio-announcement-modal__button"
      >
        Check it Out
      </BravadoButtonV3>
    </div>
  </AnnouncementModalContent>
</template>

<script>
import Vue from 'vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3';
import BravadoText from '~/components/common/BravadoText/BravadoText';
import AnnouncementModalContent from '~/components/common/AnnouncementModal/AnnoucementModalContent';

export default Vue.extend({
  name: 'PublicPortfolioAnnouncement',
  components: { AnnouncementModalContent, BravadoButtonV3, BravadoText },
});
</script>

<style lang="scss" scoped>
.public-portfolio-announcement-modal {
  background: linear-gradient(97.4deg, #204171 0%, #5860a6 100%);
  box-shadow: var(--theme-elevation-15);

  &__content {
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: rgba(var(--white));

    @include mq('sm') {
      flex: 1;
      padding: 24px 0 24px 24px;
    }
  }

  &__title {
    margin-bottom: 16px;
  }

  &__headline {
    margin-bottom: 24px;
  }

  &__button {
    color: var(--gray-90);
    background-color: rgba(var(--white));
    box-shadow: 0 12px 160px rgba(255, 212, 101, 0.49);
    margin-bottom: 20px;

    @include mq('md') {
      margin-bottom: 0;
    }
  }
}
</style>
